<template>
  <div>
    <group-card title="User List" icon="people" padded>
      <template slot="actions">
        <md-button
          @click="openNewUser"
          class="md-icon-button md-primary md-simple new-app-button"
        >
          <md-icon
            id="new-app-icon"
          >note_add</md-icon>
          New User
          <md-tooltip md-direction="top">Add new user</md-tooltip>
        </md-button>
        <loading-icon-button
          @click="refreshUsers(true)"
          tooltip="Refresh"
          :loading="progress_indicator.user_list"
        >
          refresh
        </loading-icon-button>
      </template>
      <!-- User Details Editor -->
      <md-dialog :md-active.sync="show.edit_user_dialog">
        <md-dialog-title>Edit User</md-dialog-title>
        <div class="md-layout">
          <!-- First Name -->
          <validated-text-input
            class="md-layout-item md-small-size-100 md-size-20"
            label="First Name"
            v-model="edit_user.first_name"
          />
          <!-- Last Name -->
          <validated-text-input
            class="md-layout-item md-small-size-100 md-size-20"
            label="Last Name"
            v-model="edit_user.last_name"
          />
          <!-- Email -->
          <validated-text-input
            class="md-layout-item md-small-size-100 md-size-40"
            label="Email"
            v-model="edit_user.email"
            :melissaCheckType="bypassMelissa ? '' : 'email'"
            @is-melissa-check-passed-changed="updateMelissaCheck"
            required
          />
          <!-- Phone -->
          <validated-text-input
            label="Phone"
            ref="phone_input"
            class="md-layout-item"
            v-model="edit_user.phone_number"
            :minLength="10"
            :maxLength="12"
            errormsg="Please enter a valid phone number, format must be a valid Australian number and only include numbers or +"
            melissaCheckType="phone"
            @is-melissa-check-passed-changed="updateMelissaCheck"
            required
          />
          <!-- Password -->
          <validated-text-input
            class="md-layout-item md-small-size-100 md-size-20"
            label="Password"
            v-model="edit_user.password"
          />
          <!-- Seating -->
          <validated-select-input
            class="md-layout-item md-small-size-100 md-size-20"
            label="Seating"
            v-model="edit_user.seating"
            :options="['external', 'internal']"
            force
          />
          <!-- Status-->
          <validated-select-input
            class="md-layout-item md-small-size-100 md-size-20"
            label="Status"
            v-model="edit_user.status"
            :options="['Active', 'Inactive', 'Pending']"
            force
          />
          <!-- Pod -->
          <validated-autocomplete-input
            class="md-layout-item md-small-size-100 md-size-20"
            label="Primary Pod"
            v-model="edit_user.primary_pod.name"
            :options="options.user_pods"
            :focus=false
            force
          />
          <!-- Multiple Roles -->
          <validated-select-input
            class="md-layout-item md-small-size-100 md-size-20"
            label="Primary Pod Roles" v-model="edit_user.primary_pod.roles"
            :options="options.roles"
            force
            multiple
          />
          <md-button
            class="md-layout-item md-size-10 md-simple md-primary"
            @click="openCloseSecondaryPods"
            :disabled="!userHasPermission('view secondary-pods') || !edit_user.id"
          >
            Edit Secondary Pods
          </md-button>
          <md-checkbox
            v-if="userHasRole('super-admin')"
            type="checkbox"
            class="md-layout-item md-small-size-100 md-size-25"
            v-model="bypassMelissa"
          >
            This email is correct and I want to continue process
          </md-checkbox>
          <!-- esign_id -->
          <validated-text-input
            class="md-layout-item md-small-size-100 md-size-40"
            label="E-Sign ID"
            v-model="edit_user.esign_id"
          />
          <!-- User Tags -->
          <validated-select-input
            class="md-layout-item md-small-size-100 md-size-20"
            label="Tag" v-model="edit_user.tags"
            :options="['contact-owner','marketing-excluded']"
            multiple
          />
        </div>
        <br>
        <!-- Co-branding section -->
        <ValidationObserver v-slot="{ invalid }">
        <div v-if="edit_user.primary_pod.roles.includes('Agent')">
          <md-dialog-title>Agent Co-Branding</md-dialog-title> <br>
            <div class="md-layout">
              <validated-number-input
                class="md-layout-item"
                label="Zink Id"
                v-model="edit_user.id"
                :disabled="true"
              />
              <validated-number-input
                class="md-layout-item"
                label="Affiliate Id"
                v-model="edit_user.hubspot.affiliate_id"
                :disabled="true"
              />
            </div>
            <div class="md-layout">
              <!-- Search Address -->
              <search-address
                :prefixLabel="prefixLabel"
                :address="edit_user.hubspot.address"
                @update-address="updateAddress"
              ></search-address>

              <validated-autocomplete-input
                class="md-layout-item"
                label="State"
                v-model="edit_user.hubspot.state"
                :options="states"
              />
              <validated-text-input
                label="Phone"
                ref="phone_input"
                class="md-layout-item"
                v-model="edit_user.phone_number"
                :minLength="10"
                :maxLength="12"
                errormsg="Please enter a valid phone number, format must be a valid Australian number and only include numbers or +"
              />
            </div>
            <div class="md-layout">
              <validated-text-input
                class="md-layout-item"
                label="QR Code"
                v-model="edit_user.hubspot.qr_code_url"
                regex="^(https?:\/\/)?([\w\d-_]+)\.([\w\d-_\.]+)\/?\??([^#\n\r]*)?#?([^\n\r]*)"
                errormsg="Please enter a valid url. E.g: https://www.1800approved.com.au/"
              />
              <validated-text-input
                class="md-layout-item"
                label="Role"
                v-model="edit_user.hubspot.role"
                alphaSpaces
                regex="^\S+(?: \S+)*$"
                errormsg="Please enter a valid role, It must only contain alphabetic characters. Space allowed between words."
              />
            </div>
        </div>
          <md-dialog-actions>
            <md-button class="md-primary md-simple" @click="onEditUserCancel">Cancel</md-button>
            <md-button class="md-primary" :disabled="invalid || (!isMelissaCheckPassed && !bypassMelissa)" @click="onEditUserSave">Save</md-button>
          </md-dialog-actions>
        </ValidationObserver>
      </md-dialog>

      <md-dialog :md-active.sync="show.secondary_pods_dialog" md-scrollable>
        <md-dialog-title>Edit Secondary Pods</md-dialog-title>
        <md-dialog-actions>
          <md-button
            @click="addNewSecondaryPod"
            class="md-primary md-layout-item md-size-100"
          >
            Add New Pod
            <md-tooltip md-direction="top">Add new secondary pod for user</md-tooltip>
          </md-button>
        </md-dialog-actions>
        <md-dialog-content>
          <table class="data-table wide">
            <thead>
              <tr>
                <th>Pod name</th>
                <th>Pod Roles</th>
                <th class="right">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="pod, index in edit_user.secondary_pods"
                :key="pod.name"
              >
                <td>
                  <validated-autocomplete-input class="md-size-25"
                    label="Pod" v-model="pod.name"
                    :options="options.user_pods"
                    :focus="false"
                    force
                  />
                </td>
                <td>
                  <validated-select-input
                  class="md-size-25"
                  label="Pod Roles" v-model="pod.roles"
                  :options="options.roles"
                  force
                  multiple
                  >
                  </validated-select-input>
                </td>
                <td>
                  <md-button
                    class="md-danger md-simple"
                    @click="() => removePod(index)"
                  >
                    Remove pod
                  </md-button>
                </td>
              </tr>
            </tbody>
          </table>
        </md-dialog-content>
        <md-dialog-actions>
          <md-button class="md-primary md-simple" @click="openCloseSecondaryPods(false)">Cancel</md-button>
          <md-button class="md-primary md-simple" @click="onEditSecondaryPodsSave">Save</md-button>
        </md-dialog-actions>
      </md-dialog>

      <!-- API Access Token Editor -->
      <md-dialog :md-active.sync="show.edit_api_token_dialog">
        <md-dialog-title>API Access ({{ edit_user | name }})</md-dialog-title>
        <table class="data-table wide">
          <thead>
          <tr>
            <th>Name</th>
            <th>Created At</th>
            <th>Last Used</th>
            <th class="right">Actions</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="api_token in edit_user.api_tokens" :key="api_token.id">
            <td>{{ api_token.name }}</td>
            <td>{{ api_token.created_at | datetime }}</td>
            <td>{{ api_token.last_used_at | datetime }}</td>
            <td class="right">
              <loading-icon-button
                class="md-danger"
                @click="removeToken(api_token)"
                tooltip="Remove"
                :loading="progress_indicator.remove_api_token_id == api_token.id"
              >
                close
              </loading-icon-button>

            </td>
          </tr>
          <tr>
            <td colspan="3">
              <!-- New API Token Name -->
              <validated-text-input
                class="md-layout-item md-small-size-100 md-size-40"
                label="New API Token Name"
                v-model="new_api_token.name"
              />
            </td>
            <td class="right">
              <loading-icon-button
                @click="createToken()"
                tooltip="Create"
                :loading="progress_indicator.create_api_token"
              >
                add
              </loading-icon-button>
            </td>
          </tr>
          </tbody>
        </table>

        <md-dialog-actions>
          <md-button class="md-primary md-simple" @click="onEditTokensClose">Close</md-button>
        </md-dialog-actions>
      </md-dialog>

      <!-- API Token Display -->
      <md-dialog :md-active.sync="show.api_token_dialog">
        <md-dialog-title>API Access Token</md-dialog-title>

        <md-dialog-content>
          <p>{{ edit_user.username }} now has the API access token named '{{ new_api_token.name }}'.</p>
          <br>
          <p class="md-caption">Token:</p>
          <pre class="md-title">Bearer {{ new_api_token.token }}</pre>
          <br>
          <p>Please note down the token, it can only be viewed once!</p>
        </md-dialog-content>

        <md-dialog-actions>
          <md-checkbox
            v-model="new_api_token.token_seen">
              Token written down
            </md-checkbox>
          <md-button
            class="md-primary md-simple"
            @click="onCreateTokenClose"
            :disabled="!new_api_token.token_seen">
              Close
          </md-button>
        </md-dialog-actions>
      </md-dialog>

      <!-- User Listing Table -->
      <UserList
        :items="users"
        :loading="progress_indicator.user_list"
        @open-user="openUser"
        @open-api-token="openAPITokens"
      >
      </UserList>
    </group-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import filters from "@/components/utils/filters";
import ValidatedInputs from '@/components/ValidatedInput';
import LoadingIconButton from '@/components/LoadingIconButton';
import UserList from "../components/UserList";
import { GroupCard } from "@/components";
import ValidatedSelectInput from "../components/ValidatedInput/ValidatedSelectInput";
import SearchTextInput from '../components/ValidatedInput/SearchTextInput'
import SearchAddress from '@/components/SearchAddress.vue';

export default {
  components: {
    ValidatedSelectInput,
    UserList,
    ...ValidatedInputs,
    LoadingIconButton,
    GroupCard,
    SearchTextInput,
    SearchAddress
  },
  data() {
    return {
      users: [],
      bypassMelissa: false,
      progress_indicator: {
        user_list: false,
        load_user_id: null,
        load_api_tokens_user_id: null,
        remove_api_token_id: null,
        create_api_token: false,
      },
      edit_user: {
        id: null,
        esign_id: '',
        username: '',
        password: '',
        email: '',
        phone_number: '',
        primary_pod: {
          name: '',
          roles: []
        },
        seating: '',
        status: '',
        tags: [],
        secondary_pods: [],
        api_tokens: [],
      },
      new_api_token: {
        name: '',
        token_seen: false,
        token: '',
      },
      show: {
        edit_user_dialog: false,
        edit_api_token_dialog: false,
        api_token_dialog: false,
        secondary_pods_dialog: false
      },
      isMelissaCheckPassed: false,
      prefixLabel: ''
    };
  },
  computed: {
    ...mapGetters({
      savedUsers: 'administrationUsers',
      options: 'options',
      userHasPermission: 'userHasPermission',
      userHasRole: "userHasRole"
    }),
    states() {
      return this.options.country_states.Australia;
    }
  },
  methods: {
    addNewSecondaryPod () {
      const newPod = { name: '', roles: [] }
      this.edit_user.secondary_pods.push(newPod)
    },
    async refreshUsers(force=false){
      this.progress_indicator.user_list = true;

      let status = await this.$store.dispatch('fetch_administration_users', force);

      if(status){
        this.users = this.savedUsers();
      }else{
        console.log('Create error dialog');
      }

      this.progress_indicator.user_list = false;
    },
    async openUser(user_list_entry){
      this.progress_indicator.load_user_id = user_list_entry.id;

      let { data: user } = await axios.get(`/api/v1/administration/users/${user_list_entry.id}`);
      this.setUser(user);
      this.show.edit_user_dialog = true;

      this.progress_indicator.load_user_id = null;
    },
    openNewUser(){
      this.setUser();
      this.show.edit_user_dialog = true;
    },
    async openAPITokens(user_list_entry){
      this.progress_indicator.load_api_tokens_user_id = user_list_entry.id;

      try{
        let { data: user } = await axios.get(`/api/v1/administration/users/${user_list_entry.id}`);
        this.setUser(user);
        this.show.edit_api_token_dialog = true;
      }catch(error){
          console.error('Save user request failed');
          console.error(error);
      }

      this.progress_indicator.load_api_tokens_user_id = null;
    },
    async updateAddress(data) {
        this.edit_user.hubspot.address = data;
        this.edit_user.hubspot.state = data.state ?? "";
    },
    setUser(user={}){
      this.edit_user = {
        id: null,
        email: '',
        phone_number: '',
        password: '',
        first_name: '',
        last_name: '',
        seating: 'external',
        status: 'Active',
        tags: [],
        primary_pod: {
          name: '',
          roles: []
        },
        secondary_pods: [],
        hubspot: {
          affiliate_id: '',
          address: {}
        },
        api_tokens: [],
        ...user,
      };
    },
    onEditUserCancel(){
      this.show.edit_user_dialog = false;
      this.bypassMelissa = false;
    },
    async onEditUserSave(){
      this.show.edit_user_dialog = false;
      this.bypassMelissa = false;

      try{
        await axios.post(`/api/v1/administration/users`, this.edit_user);
        this.setUser();
        this.refreshUsers(true);
      }catch(error){
          console.error('Save user request failed');
          console.error(error);
      }
    },
    onEditTokensClose(){
      this.show.edit_api_token_dialog = false;
      this.refreshUsers(true);
    },
    async removeToken(api_token){
      this.progress_indicator.remove_api_token_id = api_token.id;

      try{
        await axios.delete(`/api/v1/administration/api_tokens/${api_token.id}`);

        let { data: user } = await axios.get(`/api/v1/administration/users/${this.edit_user.id}`);
        this.setUser(user);

      }catch(error){
          console.error('API Token delete request failed');
          console.error(error);
      }

      this.progress_indicator.remove_api_token_id = null;
    },
    async createToken(){
      this.progress_indicator.create_api_token = true;

      try{
        let { data: token } = await axios.post(`/api/v1/administration/api_tokens`, { user_id: this.edit_user.id, name: this.new_api_token.name });

        let { data: user } = await axios.get(`/api/v1/administration/users/${this.edit_user.id}`);
        this.setUser(user);

        this.new_api_token.token = token;
        this.new_api_token.token_seen = false;
        this.show.api_token_dialog = true;

      }catch(error){
          console.error('API Token creation request failed');
          console.error(error);
      }

      this.progress_indicator.create_api_token = false;
    },
    onCreateTokenClose(){
      this.show.api_token_dialog = false;
        this.new_api_token.name = '';
        this.new_api_token.token = '';
        this.new_api_token.token_seen = false;
    },
    openCloseSecondaryPods (open = true) {
      this.show.secondary_pods_dialog = open;
    },
    async onEditSecondaryPodsSave () {
      await axios.post('/api/v1/administration/users/secondary_pods', this.edit_user)
      this.show.secondary_pods_dialog = false
      this.show.edit_user_dialog = false;
      this.refreshUsers(true);
    },
    removePod (index) {
      this.edit_user.secondary_pods.splice(index, 1)
    },
    updateMelissaCheck(isMelissaCheckVal) {
        this.isMelissaCheckPassed = isMelissaCheckVal;
    }
  },
  async beforeCreate() {
    const params = {
      types: [
        'country_states',
        'roles',
        'user_pods',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
  async created(){
    this.refreshUsers();
  },
  filters: {
    ...filters,
  },
};
</script>

<style scoped lang="scss">
  @import "@/assets/scss/theme.scss";
  @import "../assets/scss/md-custom/_ausloans-colors.scss";

  md-dialog{
    overflow: scroll;
  }
.sub-header {
  background-color: $ausloans-blue-light !important;
  border-radius: 5px;
  margin-bottom: 15px;
  color: white;
}

.co-branding {
  margin: 20px 0px;
}

</style>
